const getRad = (x) => (x * Math.PI) / 180

export const getDistance = (g1, placeObject) => {
  const g2 = { lat: placeObject.lat(), lng: placeObject.lng() }
  const dLat = getRad(g2.lat - g1.lat)
  const dLong = getRad(g2.lng - g1.lng)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(getRad(g1.lat)) * Math.cos(getRad(g2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return 6378137 * c
}
